module.exports = __webpack_public_path__ + "static/media/daimler-go-drive.e4bc62f8.png";